import React, { useState } from 'react'
import { connect } from 'react-redux'
import { StoreState } from '../../state/configureStore'
import { AnyAction, Dispatch } from 'redux'
import { renameMachine } from '../../state/actions/machine'
import { Text } from 'recharts'
import { MachineDetails } from './machineDetails'
import { SaveModal } from '../../components/molecules/SavingModal'
import { PostUtils } from '../../utils/request'

type IComponentProps = IComponentOwnProps & IComponentStoreProps & IComponentDispatchProps;

type IComponentStoreProps = ReturnType<typeof mapStateToProps>;
type IComponentDispatchProps = ReturnType<typeof mapDispatchToProps>;

interface IComponentOwnProps {
  open: boolean;
  closeModal: Function;
  details: MachineDetails | undefined;
}

function VerifyRestartModal(props: IComponentProps): React.ReactElement {
  const [savingStatus, setSavingStatus] = useState<boolean | null>(null)
  const [savingFailed, setSavingFailed] = useState<boolean | null>(null)
  const [statusMessage, setStatusMessage] = useState<string | undefined>(undefined)

  const onVerify = async () => {
    if (!props.details?.deviceId) return;

    setSavingStatus(true);
    setSavingFailed(null);
    setStatusMessage(undefined);

    try {
      await PostUtils("iot-device/RestartDeviceApplication/" + props.details.deviceId);

      setSavingStatus(false);
      setSavingFailed(false);

    } catch (error) {
      setSavingStatus(false);
      setSavingFailed(true);
    }
  }

  return (
    <SaveModal
      title={'Restart hub'}
      open={props.open}
      savingFailedMessage={statusMessage || 'Restarting hub failed! Try again later.'}
      savingOngoingMessage={statusMessage}
      savingSuccessMessage={statusMessage || 'Successfully restarted the hub!'}
      saveButtonText={'Restart'}
      closeModal={() => { props.closeModal() }} 
      onSave={onVerify}
      saving={savingStatus ?? false}
      savingFailed={savingFailed === true}
      savingDisabled={savingStatus ?? false}
      savingSuccessful={savingFailed === false}
      savingOngoing={false}
      setSavingFailed={setSavingFailed}>
      <Text> 
        This action will restart the machine. 
        Please ensure the affected store is notified beforehand and that the hub is online. 
        This process may take a couple of minutes. This will only work for hubs with SW version equal to or greater than 1.0.3.
      </Text>
    </SaveModal>
  )
}

const mapStateToProps = (state: StoreState) => ({
  machine_saving: state.machine_saving
})

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => ({
  renameMachine: (id: string, name: string) => dispatch(renameMachine(id, name))
})

export default connect(mapStateToProps, mapDispatchToProps)(VerifyRestartModal)